import AICreateFormPreviewPage from '@/views/forms/AICreateFormPreviewPage'

export default function AICreateFormPreviewScreen() {
  return <AICreateFormPreviewPage />
}
